import React, { useEffect, useState } from 'react';
import { DateRangePickerComponent } from '../../../../Components/Controls/DateRangePickerComponent/DateRangePickerComponent';
import moment from 'moment';

const PerformanceDateRangePicker = ({ onDateRangeChange, withoutDiff, key }) => {
  const [dateRange, setDateRange] = useState({
    dateFrom: null,
    dateTo: null,
  });
  useEffect(() => {
    if (
      dateRange.dateFrom &&
      dateRange.dateTo &&
      (withoutDiff ||
        moment(dateRange.dateFrom).diff(moment(dateRange.dateTo)) < 0)
    ) {
      onDateRangeChange({
        startDate: moment(dateRange.dateFrom)
          .startOf('day')
          .format('YYYY-MM-DD'),
        endDate: moment(dateRange.dateTo).endOf('day').format('YYYY-MM-DD'),
      });
    } else if (!dateRange.dateFrom && !dateRange.dateTo) {
      onDateRangeChange({
        startDate: null,
        endDate: null,
      });
    }
  }, [dateRange.dateFrom, dateRange.dateTo]);
  return (
    <DateRangePickerComponent
      key={key ?? ''}
      ranges={[
        {
          startDate: dateRange.dateFrom,
          endDate: dateRange.dateTo,
          key: 'selection',
        },
      ]}
      onClearClicked={() =>
        setDateRange(() => ({
          dateFrom: null,
          dateTo: null,
        }))
      }
      onDateChanged={(e) => {
        setDateRange(() => ({
          dateFrom: e.selection.startDate,
          dateTo: e.selection.endDate,
        }));
      }}
    />
  );
};
export default PerformanceDateRangePicker;
